<script setup>
import { useAppStore } from '@/stores/App'
import { useDisplay } from 'vuetify'

// mobile breakpoint
const { xs } = useDisplay()
const app = useAppStore()
const staticURLImg = useRuntimeConfig().public.staticURLImg
</script>

<template>
    <v-row id="3d" class="bg-grey-darken-4 justify-center slide-from-right rounded">
        <v-col cols="10" class="my-16 rounded st-box-shadow">
            <v-row>
                <v-col cols="12">
                    <v-row dense class="align-center">
                        <!-- <v-col cols="2" class="text-h4 text-sm-h2 text-md-h1 text-center font-weight-medium">
                            3D
                        </v-col> -->
                        <v-col v-for="shot in app.st3DShots" :key="shot.alt" cols="2" class="text-center">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + shot.source"
                                :height="xs ? 64 : 128"
                                cover
                                class="rounded elevation-1"
                                alt="shot.alt"
                            ></v-img>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="8" class="container">
                    <v-img
                        id="f1"
                        :src="staticURLImg + `ex3d-blender-shots-anim.gif`"
                        height="100%"
                        cover
                        class="rounded elevation-1"
                        alt="Glacier White blender shot animated"
                    ></v-img>
                </v-col>
                <v-col cols="12" md="4" class="align-self-lg-center">
                    <v-row>
                        <v-col cols="12" class="text-justify align-self-center st-card-text">
                            Our expertise extends to the realm of 3D design. We showcased this with the creation of the
                            3D model for our Glacier White skin. Additionally, our talented team of 3D artists is here
                            to bring your vision to life, whether you require a UI that incorporates 3D elements or
                            standalone 3D models and product shots. We're here to deliver exceptional results for all
                            your 3D needs.
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <v-btn
                                text="Contact Us"
                                to="/support"
                                size="x-large"
                                color="secondary"
                                aria-label="Contact satYatunes"
                            ></v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
